import { ReactNode } from 'react';
import { IPickerOption, IPickerProps } from '../../types';
import PickerOption from '../../components/PickerOption/PickerOption';
import SearchInput from 'src/view/components/Controls/SearchInput/SearchInput';
import { EmptyList } from 'src/view/components/EmptyList/EmptyList';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import '../../components/PickerOption/style.scss';
import '../../style.scss';

type TStaticList<T> = Pick<IPickerProps<T>, 'searchable' | 'emptyText' | 'viewedSize' | 'emptyListTextClassName' | 'optionClassName'>;

interface IProps<T> extends TStaticList<T> {
  options: IPickerOption[];
  searchValue?: string;
  showSearch?: boolean;
  renderItem: (item: T | IPickerOption | undefined, index: number) => ReactNode;
  onSearch: (search: string) => void;
}

const PickerStaticListContent = <T,>(props: IProps<T>): JSX.Element | null => {
  return (
    <>
      {props.showSearch ? (
        <PickerOption
          optionClassName={`picker-option__search ${props.viewedSize === 'small' ? 'picker-option__search_small' : ''}`}
          viewedSize={props.viewedSize === 'small' ? 'small' : 'normal'}
        >
          <SearchInput
            withResetIcon
            customPlaceholder
            onChangeText={props.onSearch}
            value={props.searchValue}
            placeholder="txt_search"
            customPlaceholderIconSize={props.viewedSize === 'normal' ? undefined : 14}
            inputClassName="custom-picker__search-input"
            customPlaceholderTextClassName={`${props.viewedSize === 'normal' ? 'text-size-16' : 'text-size-12'}`}
          />
        </PickerOption>
      ) : null}

      <ScrollableBlock showScrollbar scrollbarSize="small">
        {props.options.length ? (
          props.options.map(props.renderItem)
        ) : (
          <EmptyList text={props.emptyText || 'no_results_found'} textClassName={`${props.emptyListTextClassName || ''}`} />
        )}
      </ScrollableBlock>
    </>
  );
};

export default PickerStaticListContent;
